import { Link } from "react-router-dom";
import { featuredInspirations } from "../../../mocks/inspirations";

export default function FeaturedInspiration() {
  return (
    <section className="py-28 px-8 md:px-16 max-w-screen-xl mx-auto">
      {/* Header */}
      <div className="text-center mb-16">
        <p
          className="text-[#B5A898] text-[10px] tracking-[0.45em] uppercase mb-4"
          style={{ fontFamily: "'Inter', sans-serif" }}
        >
          Curated For You
        </p>
        <h2
          className="text-[#2C2825] text-4xl md:text-5xl mb-4"
          style={{ fontFamily: "'Playfair Display', serif", fontWeight: 400 }}
        >
          Featured Inspiration
        </h2>
        <p
          className="text-[#8B8378] text-sm leading-relaxed max-w-md mx-auto"
          style={{ fontFamily: "'Inter', sans-serif", fontWeight: 300 }}
        >
          A curated selection of calm interiors to save, explore, and revisit.
        </p>
      </div>

      {/* Editorial Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-14">
        {featuredInspirations.map((post) => (
          <Link
            key={post.id}
            to={post.path}
            className="group cursor-pointer block"
          >
            {/* Image */}
            <div className="relative overflow-hidden rounded-lg bg-[#F5F1E8] mb-5 aspect-[4/5]">
              <img
                src={post.image}
                alt={post.title}
                className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-colors duration-500" />
              <div className="absolute top-4 left-4">
                <span
                  className="bg-[#FAF7F0]/90 text-[#6B5E53] text-[9px] px-3 py-1.5 rounded-full tracking-wider"
                  style={{ fontFamily: "'Inter', sans-serif" }}
                >
                  {post.category}
                </span>
              </div>
            </div>

            {/* Text */}
            <h3
              className="text-[#2C2825] text-lg md:text-xl leading-snug mb-2.5 group-hover:text-[#6B5E53] transition-colors duration-200"
              style={{ fontFamily: "'Playfair Display', serif", fontWeight: 500 }}
            >
              {post.title}
            </h3>
            <p
              className="text-[#A89A8E] text-xs leading-relaxed flex items-center gap-1.5 group-hover:text-[#6B5E53] transition-colors"
              style={{ fontFamily: "'Inter', sans-serif" }}
            >
              Read more
              <span className="w-3 h-3 flex items-center justify-center">
                <i className="ri-arrow-right-line text-[10px]" />
              </span>
            </p>
          </Link>
        ))}
      </div>

      {/* CTA */}
      <div className="text-center mt-16">
        <Link
          to="/living-room"
          className="inline-flex items-center gap-2.5 border border-[#C8BAA8] text-[#6B5E53] px-10 py-3.5 rounded-full text-xs tracking-[0.18em] hover:bg-[#2C2825] hover:text-white hover:border-[#2C2825] transition-all duration-300 cursor-pointer whitespace-nowrap uppercase"
          style={{ fontFamily: "'Inter', sans-serif" }}
        >
          See More Inspiration
          <span className="w-3.5 h-3.5 flex items-center justify-center">
            <i className="ri-arrow-right-line text-xs" />
          </span>
        </Link>
      </div>
    </section>
  );
}
